import PropTypes from "prop-types";
import TextButton from "@shared/v2/TextButton";
import TextLink from "@shared/v2/TextLink";

const BrokerageExpenses = ({
  transactionResults: {
    team_member_incomes: teamMemberIncomes,
    meta: {
      brokerage_cap: brokerageCap,
      for_brokerage_cap: forBrokerageCap,
      cap_less_total: capLessTotal,
      has_developer_role: hasDeveloperRole,
      is_over: isOver,
      royalty_cap: royaltyCap,
      total,
    },
  },
  resetTeamMemberIncome,
}) => {
  const overUnderColor = isOver ? "red" : "green";

  const canReset = (brokerageExpenseAmount) =>
    brokerageExpenseAmount && brokerageExpenseAmount > 0 && hasDeveloperRole;

  return (
    <div className="tw-flex tw-flex-col tw-gap-[12px] tw-mt-[32px]">
      <div className="tw-flex tw-border-solid tw-border-x-0 tw-border-t-0 tw-border-b-[1px]">
        <div className="tw-basis-6/12">Listing</div>
        <div className="tw-basis-6/12">Expense Amount</div>
      </div>
      {teamMemberIncomes.length === 0 && <div>No results match that given user/slug</div>}
      {teamMemberIncomes?.map(
        ({
          brokerage_expense_amount: brokerageExpenseAmount,
          id,
          listing_url: listingUrl,
          transaction_name: transactionName,
          listing_id: listingId,
        }) => (
          <div className="tw-flex" key={id}>
            <div className="tw-basis-6/12">
              <TextLink href={listingUrl} target="_blank" rel="noopener noreferrer">
                {transactionName}
              </TextLink>
            </div>
            <div className="tw-basis-5/12">{brokerageExpenseAmount}</div>
            {canReset(brokerageExpenseAmount) && (
              <div className="tw-basis-1/12">
                <TextButton onClick={() => resetTeamMemberIncome(forBrokerageCap, id, listingId)}>
                  Reset
                </TextButton>
              </div>
            )}
          </div>
        ),
      )}
      <div className="tw-flex">
        <div className="tw-basis-6/12" />
        <div className="tw-basis-6/12">Total Accumulated For Cap Period</div>
      </div>
      <div className="tw-flex">
        <div className="tw-basis-6/12" />
        <div className="tw-basis-6/12">${total}</div>
      </div>
      <div className="tw-flex">
        <div className="tw-basis-6/12" />
        <div className="tw-basis-6/12">Agent&apos;s {forBrokerageCap ? "Brokerage Cap" : "Royalty Cap"}</div>
      </div>
      <div className="tw-flex">
        <div className="tw-basis-6/12" />
        <div className="tw-basis-6/12">${forBrokerageCap ? brokerageCap : royaltyCap}</div>
      </div>
      <div className="tw-flex">
        <div className="tw-basis-6/12" />
        <div className="tw-basis-6/12">Agent is {isOver ? "over" : "under"} by</div>
      </div>
      <div className="tw-flex">
        <div className="tw-basis-6/12" />
        <div className="tw-basis-6/12">
          <span style={{ color: overUnderColor }}>${capLessTotal}</span>
        </div>
      </div>
    </div>
  );
};

BrokerageExpenses.propTypes = {
  transactionResults: PropTypes.shape({
    team_member_incomes: PropTypes.arrayOf(
      PropTypes.shape({
        brokerage_expense_amount: PropTypes.number,
        id: PropTypes.string.isRequired,
        listing_url: PropTypes.string.isRequired,
        transaction_name: PropTypes.string.isRequired,
        listing_id: PropTypes.string.isRequired,
      }),
    ).isRequired,
    meta: PropTypes.shape({
      brokerage_cap: PropTypes.number.isRequired,
      for_brokerage_cap: PropTypes.bool.isRequired,
      cap_less_total: PropTypes.number.isRequired,
      has_developer_role: PropTypes.bool.isRequired,
      is_over: PropTypes.bool.isRequired,
      royalty_cap: PropTypes.number.isRequired,
      total: PropTypes.number.isRequired,
    }).isRequired,
  }).isRequired,
  resetTeamMemberIncome: PropTypes.func.isRequired,
};

export default BrokerageExpenses;
